import { mapState, mapActions } from 'vuex'
import util from '@/util'
import mensagens from '@/util/mensagens'
import { BToast, BSpinner } from 'bootstrap-vue'
import PainelAcesso from '@/components/layout/painelAcesso/PainelAcesso.vue'
import { validarCampos } from '@/util/validacaoUtil'
import PagamentoOferta from '@/views/login/PagamentoOferta.vue'
import constants from '@/util/constants'
import { obterImagem } from '@/util/imagem'

export default {
  name: 'ofertaBoasVindas',
  components: {
    'b-toast': BToast,
    'b-spinner': BSpinner,
    PainelAcesso,
    PagamentoOferta
  },
  computed: {
    ...mapState('auth', ['regrasLogin']),
    desabilitarCampos () {
      return this.flagsDeControle.manipulandoDados.status || this.flagsDeControle.carregandoDados.status
    },
    apresentarPagamentoPendente () {
      return this.flags.pagamentoOfertaPendente === true
    },
    apresentarOfertaBoasVindasPendente () {
      return this.flags.pagamentoOfertaPendente === false
    },
    possuiOferta () {
      return this.oferta.id !== null
    }
  },
  data: () => {
    return {
      imagemTelaDesktop: null,
      oferta: {
        id: null,
        desconto: {
          produto: null,
          porcentagem: 0,
          valor_cheio: 0,
          valor: 0,
          pacote: '',
          plano_tipo: null
        },
        descricao: '',
        mensagem: ''
      },
      flags: {
        pagamentoOfertaPendente: false
      },
      flagsDeControle: {
        manipulandoDados: {
          status: false,
          mensagem: ''
        },
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      retorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      }
    }
  },
  mounted () {
    this.obterOfertaDisponivel()
  },
  methods: {
    ...mapActions('auth', ['ActionSetRegrasLogin']),
    imagemTelaOferta () {
      return obterImagem('tela_computador_oferta.png')
    },
    imagemTelaOfertaMobile () {
      return obterImagem('tela_celular_oferta.png')
    },
    transformarOferta (ofertaDados) {
      const { plano } = ofertaDados
      return {
        id: ofertaDados.id,
        desconto: {
          produto: plano?.produto?.nome,
          porcentagem: this.calcularDesconto(ofertaDados.valor_oferta, plano?.valor),
          valor_cheio: plano?.valor,
          valor: parseFloat(ofertaDados.valor_oferta),
          pacote: this.gerarMensagemPacote(ofertaDados),
          plano_tipo: plano?.tipo
        },
        descricao: this.gerarDescricaoPromocional(ofertaDados),
        mensagem: this.gerarMensagemPromocional(ofertaDados)
      }
    },

    calcularDesconto (valorPromocional, valorCheio) {
      return ((valorCheio - parseFloat(valorPromocional)) / valorCheio).toFixed(2)
    },

    planoOfertadoEhMensal (tipo) {
      return tipo === constants.tipoPlano.mensal
    },

    gerarMensagemPromocional ({ valor_oferta: valorOferta, plano }) {
      const valorMonetario = util.formatarValorMonetarioComCifrao(valorOferta)
      const textoComplementar = this.planoOfertadoEhMensal(plano.tipo) ? ' ao mês' : ''
      return `Como oferta de boas-vindas, oferecemos o pacote de monitoramento automático das tramitações dos processos por apenas ${valorMonetario}${textoComplementar}.`
    },
    gerarDescricaoPromocional ({ plano }) {
      const { item_plano: itemPlano } = plano || {}
      const quantidade = itemPlano?.quantidade || 0
      const item = `${quantidade} ${itemPlano?.nome}`
      const mensagem = `Mantenha-se sempre atualizado com até ${item.toLowerCase()}. Oferta exclusiva para pagamento com cartão de crédito.`
      if (this.planoOfertadoEhMensal(plano.tipo)) {
        const textoValidade = this.gerarTextoValidade(plano)
        return `${mensagem} ${textoValidade}`
      }
      return mensagem
    },

    gerarTextoValidade (plano) {
      const valorCheio = plano.valor
      const recorrenciaCobranca = this.planoOfertadoEhMensal(plano.tipo) ? ' por mês' : ''
      const valorCheioMonetario = util.formatarValorMonetarioComCifrao(valorCheio)
      const textoValidade = `Após o período promocional o valor será de ${valorCheioMonetario}${recorrenciaCobranca}.`
      return textoValidade
    },
    gerarMensagemPacote ({ plano }) {
      const itemPlano = plano?.item_plano
      const nomeItem = itemPlano?.nome
      const quantidade = itemPlano?.quantidade
      return `Pacote de ${quantidade} ${nomeItem}`
    },
    mapearDadosOferta (dadosOferta = []) {
      if (util.valorVazio(dadosOferta)) {
        return
      }
      this.oferta = this.transformarOferta(dadosOferta)
    },
    async obterOfertaDisponivel () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/manager/ofertas/boas-vindas/disponivel`)
        const dadosReposta = resposta.data.retorno.dados
        this.mapearDadosOferta(dadosReposta)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      } finally {
        this.definirFlagCarregandoDados(false, '')
      }
    },
    async obterDadosEmpresa (idEmpresa) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/manager/escritorios/escritorio/${idEmpresa}`)
        const dadosResposta = resposta.data.retorno.dados
        return dadosResposta
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      } finally {
        this.definirFlagCarregandoDados(false, '')
      }
    },

    async obterDadosUsuarioLogado () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get('/manager/usuarios/usuario')
        const dadosResposta = resposta.data.retorno.dados
        return {
          escritorio: dadosResposta.empresa_id
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      } finally {
        this.definirFlagCarregandoDados(false, '')
      }
    },

    mapearDadosPayload (dadosOferta) {
      return { ativar_oferta: true, oferta_id: dadosOferta.id }
    },
    async ativarOferta () {
      const { escritorio } = await this.obterDadosUsuarioLogado()
      const dadosEmpresa = await this.obterDadosEmpresa(escritorio)
      const dadosValidos = this.validarCamposEndereco(dadosEmpresa)
      if (!dadosValidos) {
        this.emitirEventoNotificacao(mensagens.errosFormularioCadastro)
        return
      }
      try {
        this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
        const payload = this.mapearDadosPayload(this.oferta)
        const resposta = await this.axios.post('manager/ofertas/boas-vindas/confirmacao', payload)
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros
        if (this.retorno.sucesso === true) {
          this.flags.pagamentoOfertaPendente = true
          return
        } else {
          this.emitirEventoNotificacao(this.retorno.mensagem)
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      } finally {
        this.definirFlagManipulandoDados(false, '')
      }
    },

    async negarOferta () {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        const payload = { ativar_oferta: false }
        const resposta = await this.axios.post('manager/ofertas/boas-vindas/confirmacao', payload)
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros
        if (this.retorno.sucesso === true) {
          this.emitirEventoFinalizacao()
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      } finally {
        this.definirFlagManipulandoDados(false, '')
      }
    },

    emitirEventoNotificacao (mensagem) {
      const pendenciasLogin = JSON.parse(this.regrasLogin)
      pendenciasLogin.pendenteDeAceiteDeContrato = true
      this.ActionSetRegrasLogin(JSON.stringify(pendenciasLogin))
      const listaDeErros = Object.fromEntries(
        Object.entries(this.retorno.listaDeErros).map(([chave, valor]) => [chave.replace('endereco.', ''), valor])
      )
      this.$emit('enviarNotificacao', listaDeErros, (componentePai) => {
        util.criarAlertaToastDeErro(componentePai, 'Aviso', mensagem)
      })
    },

    repassarNotificacao (listaDeErros, mensagem) {
      this.retorno.listaDeErros = { ...listaDeErros }
      this.emitirEventoNotificacao(mensagem)
    },

    emitirEventoFinalizacao () {
      const pendenciasLogin = JSON.parse(this.regrasLogin)
      pendenciasLogin.ofertaBoasVindasPendente = false
      this.ActionSetRegrasLogin(JSON.stringify(pendenciasLogin))
      this.$emit('finalizandoPendencia')
    },

    validarCamposEndereco (dadosEmpresa) {
      const campos = [
        {
          campo: 'endereco.cep',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => !util.valorVazio(valor) }
          ]
        },
        {
          campo: 'endereco.endereco',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => !util.valorVazio(valor) }
          ]
        },
        {
          campo: 'endereco.numero',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => !util.valorVazio(valor) }
          ]
        },
        {
          campo: 'endereco.bairro',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => !util.valorVazio(valor) }
          ]
        },
        {
          campo: 'endereco.cidade',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => !util.valorVazio(valor) }
          ]
        }
      ]
      const validacao = validarCampos(campos, dadosEmpresa)
      this.retorno.listaDeErros = { ...validacao.listaDeErros }
      this.retorno.sucesso = !validacao.erro
      const dadosValidos = !validacao.erro
      return dadosValidos
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    }
  }
}
